module.exports = __webpack_public_path__ + "img/391.b396df59.jpg";